var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-portal", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-center mt-3" }, [
          _c("h1", [_vm._v("Oops!")]),
          _vm._v(" "),
          _c("h2", [_vm._v("403 Sem acesso ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Desculpe, você não tem permissão para aceder ao recurso!"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "error-actions" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-dark",
                attrs: { type: "button" },
                on: { click: _vm.handleBack },
              },
              [_vm._v("Voltar")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }